const map = {
	"./admin.json": 709,
	"./auth.json": 200,
	"./automations.json": 878,
	"./canned.json": 723,
	"./claude.json": 712,
	"./common.json": 251,
	"./customers.json": 179,
	"./dashboard.json": 222,
	"./errors.json": 513,
	"./globalSearch.json": 701,
	"./layout.json": 604,
	"./mailbox.json": 402,
	"./meetings.json": 236,
	"./notifications.json": 218,
	"./portal.json": 656,
	"./profile.json": 103,
	"./projectCsv.json": 801,
	"./projectDetail.json": 190,
	"./projectTemplates.json": 746,
	"./projectView.json": 666,
	"./projects.json": 800,
	"./reports.json": 829,
	"./tickets.json": 871
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;